
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.576 11.632a1.48 1.48 0 010 2.074l-1.007 1.006a4.434 4.434 0 01-4 1.2A13.335 13.335 0 01.088 5.432a4.434 4.434 0 011.2-4.001L2.294.424a1.48 1.48 0 012.074 0l2.12 2.12c.573.573.573 1.5 0 2.074l-1.753 1.76a9.135 9.135 0 004.887 4.887l1.76-1.753a1.467 1.467 0 012.074 0l2.12 2.12z","fill":"#6362D6","fill-rule":"evenodd"}})])
          )
        }
      }
    